import type { ReactElement } from 'react';
import type { Signal, SignalWithRelatedIssuesCount } from '@momentum/types';
import type { EmployeeInfo } from '../../constants';
import { SignalCard } from './SignalCard';

interface SignalGridProps {
  signals: SignalWithRelatedIssuesCount[];
  currentUserId: string;
  employeeMap: Map<string, EmployeeInfo>;
  onSignalClick: (signal: Signal) => void;
  onToggleActive: (signal: Signal, isActive: boolean) => void;
  togglingSignalId: string | null;
}

export const SignalGrid = ({
  signals,
  currentUserId,
  employeeMap,
  onSignalClick,
  onToggleActive,
  togglingSignalId,
}: SignalGridProps): ReactElement => (
  <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
    {signals.map((signal) => (
      <SignalCard
        key={signal._id}
        signal={signal}
        currentUserId={currentUserId}
        owner={employeeMap.get(signal.createdBy)}
        employeeMap={employeeMap}
        onSignalClick={onSignalClick}
        onToggleActive={onToggleActive}
        isTogglingActive={togglingSignalId === signal._id}
      />
    ))}
  </div>
);
